export const formatStatusLabel = (status?: string | null): string => {
  if (typeof status !== "string") {
    return "";
  }

  const trimmed = status.trim();
  if (!trimmed) {
    return "";
  }

  return trimmed
    .split(/[\s_-]+/)
    .filter(Boolean)
    .map((segment) => segment.charAt(0).toUpperCase() + segment.slice(1).toLowerCase())
    .join(" ");
};

